import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './components/App';
import configureStore from './features/configureStore';
import Internationalize from './components/Internationalize';
import * as serviceWorker from './serviceWorker';
import './utils/debug';

ReactDOM.render(
  <Provider store={configureStore()}>
    <Internationalize>
      <App />
    </Internationalize>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
